import { attr } from 'redux-orm';
import Model from '../base-model';
import { topicActions } from './topic.action';
import topicReducers from './topic.reducer';

/**
 * Teacher
 * @typedef {Object} Topic
 * @property {string} id
 * @property {string} title
 * @property {string} color
 * @property {string} discussionCount
 * @property {string} description
 */

export class Topic extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case topicActions.saveTopic:
            topicReducers.saveTopic(session, action.topic);
            break;
        case topicActions.removeTopic:
            topicReducers.removeTopic(session, action.id);
            break;
        case topicActions.removeTopics:
            topicReducers.removeTopics(session);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Topic: ${this.title}`
    }
}

Topic.modelName = 'Topic';

Topic.fields = {
    id: attr(),
    title: attr(),
    color: attr(),
    discussionCount: attr(),
    description: attr(),
}